import { awsPartitionFromUse } from "@p0security/shared/integrations/resources/aws/gov-cloud";
import {
  accessAnalyzerName,
  iamAssessmentInstallCommands,
  iamAssessmentTerraform,
} from "@p0security/shared/integrations/resources/aws/policy/iam-assessment";
import { arnInfo } from "@p0security/shared/integrations/resources/aws/util";
import Link from "antd/lib/typography/Link";
import { CommandDisplay } from "components/Integrations/CommandDisplay";

import { AwsInstaller } from "../types";

const toAnalyzerName = ({
  existingArn,
  defaultName,
}: {
  existingArn?: string;
  defaultName: string;
}): string => {
  if (!existingArn) {
    return defaultName;
  }

  try {
    return arnInfo(existingArn, true)?.name ?? defaultName;
  } catch {
    return defaultName;
  }
};

const iamAssessmentInstructions: AwsInstaller["iam-assessment"]["instructions"] =
  (context, id) => {
    const awsPartition = awsPartitionFromUse(
      context.config,
      id,
      "iam-assessment"
    );
    return {
      help: (
        <>
          To install P0 on this account, provision P0&apos;s access using{" "}
          <Link
            href={`https://${id}.signin.aws.amazon.com/console`}
            target="_blank"
            rel="noopener"
          >
            AWS Cloud Shell
          </Link>{" "}
          or Terraform:
        </>
      ),
      commands: {
        shell: [
          {
            command: iamAssessmentInstallCommands(
              context,
              {},
              {
                gcloudServiceAccountId:
                  context.config.base[id]?.serviceAccountId,
                awsAccountId: id,
                awsPartition,
              }
            ),
          },
        ],
        iac: [
          {
            command: iamAssessmentTerraform(
              context,
              {},
              context.config.base[id]?.serviceAccountId,
              awsPartition
            ),
          },
        ],
      },
    };
  };

export const awsIamAssessmentInstaller: AwsInstaller["iam-assessment"] = {
  instructions: iamAssessmentInstructions,
  items: {
    accessAnalyzerArn: {
      labeler: (context, id) => {
        const analyzerName = toAnalyzerName({
          existingArn:
            context.config["iam-assessment"]?.[id]?.accessAnalyzerArn,
          defaultName: accessAnalyzerName,
        });

        return (
          <>
            This is the ARN of the access analyzer you created during set-up. To
            get the ARN, run the following command:
            <CommandDisplay
              commands={`aws accessanalyzer get-analyzer \\
  --analyzer-name ${analyzerName}`}
            />
          </>
        );
      },
    },
  },
};
